"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral")),
    _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _templateObject() {
  var a = (0, _taggedTemplateLiteral2["default"])(["\n  mutation setAssetMissing($assetId: String!) {\n    setAssetMissing(assetId: $assetId)\n }\n"]);
  return _templateObject = function _templateObject() {
    return a;
  }, a;
}

var _default = (0, _graphqlTag["default"])(_templateObject());

exports["default"] = _default;